import { Line, mixins } from 'vue-chartjs';
import { hexToRGB } from './utils';

const { reactiveProp } = mixins;//NOTE: So that the chart updates itself when data properties got updated.

export default {
  name: 'line-chart',
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: Object,
    options: {
      type: Object,
      default: () => {
        return {
          legend: {display: false},
          layout: {padding: {left: 24, right: 24}},
          scales: {
            yAxes: [
              {ticks: {min: 0, precision: 0}}
            ]
          }
        };
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },

  watch: {
    chartData () {
      this.$data._chart.update()
    }
  }
}